import { IAction } from '@r1-frontend/shared/types/Redux';

import { EActions } from '../constants/actions';

const initialization = (salePackageId?: number, withReissue = false): IAction<EActions.initialization, { salePackageId?: number, withReissue: boolean }> => ({
    type: EActions.initialization,
    payload: {
        salePackageId,
        withReissue,
    },
});

export default initialization;
